import React, { Component } from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import FlashcardText from "./FlashcardText";
import FlashcardImage from "./FlashcardImage";
import FlashcardAudio from "../container/FlashcardAudioPlayer";
import FlashcardVideo from "../container/FlashcardVideo";
import AppHelper from "../model/AppHelper";
import { AUDIO, VIDEO, TEXT, IMAGE } from "../enum/FlashcardPageItemTypes";
import AppButton from "./AppButton";
import CountDownTimer from "../container/CountdownTimer";
import FlashcardPageMetaData from "../model/FlashcardPageMetaData";
import Checkbox from "../container/Checkbox";
import "./FlashcardPageView.css";

//import images
import TimerImage from "../images/timer.svg";
import AccomplishmentImage from "../images/accomplishment.svg";
import DisappointmentImage from "../images/disappointment.svg";
import HandImage from "../images/hand.png";
import FlashcardPage from "../model/FlashcardPage";

const portal = document.createElement('div');
document.body.append(portal);

const ALERT_TYPES = {
  TIMED_QUIZ: 1,
  CORRECT_ANSWER: 2,
  WRONG_ANSWER: 3,
  TIMED_OUT: 4,
  REATTEMPT_QUIZ: 5
};

let pageLoadState = {};

export class FlashcardPageView extends Component {
  constructor(props) {
    super(props);
    const {
      page: { pageMetaData }
    } = props;
    this.state = {
      showAlert: false,
      alertType: ALERT_TYPES.TIMED_QUIZ,
      userSelection: [],
      rendered: false,
      loaded: false,
      loadedItemsCount: 0,
      matchSources: [],
      matchTargets: [],
	  pageViewed: false,
      isExplanationExpanded: true
    };
  }

  static propTypes = {
    page: PropTypes.object,
    onQuestionSubmit: PropTypes.func,
    onDnDStart: PropTypes.func,
	isItemToBeloaded: PropTypes.bool
  };

  static defaultProps = {
    onQuestionSubmit: () => {},
    onDnDStart: () => {},
	isItemToBeloaded: false
  };

  componentDidMount(){
    let state = {};
    const { page } = this.props;
    if(page.pageItems.filter(item =>  !item.isText()).length === 0){
      state['loaded'] = true;
    }

    const { matchSources, matchTargets } = this.getShuffledMatchOptions();
    state['matchSources'] = matchSources;
    state['matchTargets'] = matchTargets;
    
    if(page.pageMetaData.canReattemptQuiz()){
      state['showAlert'] = true;
      state['alertType'] = ALERT_TYPES.REATTEMPT_QUIZ;
    }

    this.setState(state);
    this.updateRenderedState();
  }

  shuffle = (arr) => {
    let len = arr.length;
    let temp, index;
    while (len) {
      index = Math.floor(Math.random() * len--);
      temp = arr[len];
      arr[len] = arr[index];
      arr[index] = temp;
    }
    return arr;
  }

  componentWillUnmount(){
    delete pageLoadState[this.props.page.pageId];
  }

  onPageItemLoaded = (item, player) => {
    const { loaded } = this.state;
    if(loaded){
        return;
    }
    const { page } = this.props;
    const { pageId } = page; 
    var me = this;
    if(!pageLoadState[pageId]){
        pageLoadState[pageId] = {
            itemsLoadedCount: 0
        };
    }
    if(item.isAudio()){
      pageLoadState[pageId]['audioPlayer'] = (pageLoadState[pageId]['audioPlayer'] || []).concat(player); 
    }
    pageLoadState[pageId]['itemsLoadedCount'] += 1;
    if(pageLoadState[pageId]['itemsLoadedCount'] === page.pageItems.length){
        setTimeout(() => {
            me.setState({
                loaded: true
            }, () => {
              (pageLoadState[pageId]['audioPlayer'] || [])
                .forEach(player => {
                  if(!player.playing() && this.props.isPageActive){
                    player.play();
                  }
                }, this);
            });
        }, 300)
    }
    this.setState({
        loadedItemsCount: pageLoadState[pageId]['itemsLoadedCount']
    });
  }

  render() {
    const { loaded,pageViewed} = this.state;
    const { page, themeBackgroundColor, themeColor, previewLayout } = this.props;
    const hasBackgroundImage = page.pageMetaData.getBackgroundUrl() !== "";
    const backgroundImage = `url(${AppHelper.formatUrl(
      page.pageMetaData.getBackgroundUrl()
    ) || ""})`;
    var background = "";
    var opacity = (page.pageMetaData.getBackgroundOpacity() / 100);
    if(previewLayout === "fixed") {
        background = "White";
        opacity = 1;
    } else {
        background = hasBackgroundImage ? backgroundImage : page.isQuiz()? "white": this.getLinearGradient(themeBackgroundColor);
    }
    var dynamicPadding = "initial";
    if (page.pageItems.filter(item => item.isAudio()).length > 0 && page.pageItems.filter(item => item.isText()).length > 0) {
        dynamicPadding = "65px";
    }
    return (
      <div className={`flashcard-page page_${page.pageId} ${page.isQuiz() ? "quiz" : ""} ${loaded && pageViewed ? 'animate' : ''}`}>
        {this.getQuizTimer()}
        {this.getAlert()}
        {this.getPageLoadIndicator()}
        {this.getExplanation()}
        {page.pageItems.filter(item => item.isAudio()).map(this.getPageItem())}
        <div
          className="flashcard-page-background"
          style={{
            background:background ,
            color: page.isQuiz() ? "black" : themeColor,
            opacity:opacity
          }}
        />
        <div className="item-collection" style={{ paddingBottom: dynamicPadding  }}>{this.getFlashcardPageItems()}</div>
      </div>
    );
  }

  getPageLoadIndicator = () => {
    const { loadedItemsCount } = this.state;
    const { page } = this.props;
    return (
      <div className={`page-load-indicator ${this.state.loaded ? "hide-progress": ""}`}>
          {"Loading..."}
          <span className="page-load-progress-container">
              <span className="page-load-progress"
                  style={{
                      width: `${(100 * loadedItemsCount / page.pageItems.length)}%`
                  }}></span>
          </span>
      </div>
    )
  }

  getLinearGradient = color => {
    //check if color is rgb or hex format
    if (color.match("#[0-9A-Fa-f]{6}") !== null) {
      color = this.getRGBFromHex(color);
    }
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(color);
    if (!matches) {
      return color;
    }
    const rgbValues = matches[1];
    return `linear-gradient(to bottom, rgb(${rgbValues}), rgba(${rgbValues}, .8))`;
  };

  getRGBFromHex = hex => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
          result[3],
          16
        )})`
      : null;
  };

  getExplanation = () => {
    const { 
      page: { pageMetaData },
      themeBackgroundColor, 
      themeColor
    } = this.props;
    const { questionConfig, questionResponse } = pageMetaData;
    if( this.state.showAlert ||
        !pageMetaData.isQuiz() || 
        !questionConfig.hasExplanation() || 
        !questionResponse.isAnswered()){ 
        return (null); 
    }

    const bgColor = themeBackgroundColor || 'white';
    const color = themeColor || 'black';

    return (
        <div className={`explanation-container ${this.state.isExplanationExpanded ? "expand" : ""}`}>
          <div className={"explanation-overlay"}></div>
          <div className="content-wrapper">
            <div className="header" onClick={this.toggleExplanation}
              style={{
                  background: bgColor,
                  color: color
              }}>{
                  this.state.isExplanationExpanded
                  ? 'Tap to hide explanation'
                  : 'Tap to view explanation'
              }</div>
            <div className="content-container">
              <div className="content" dangerouslySetInnerHTML={{__html : questionConfig.getExplanation()}}>
              </div>
            </div>
          </div>
        </div>
    );
  }

  toggleExplanation = () => {
    this.setState({
      isExplanationExpanded: !this.state.isExplanationExpanded
    });
  }

  getAlert = () => {
    let toRender = "";
    let cls = "";
    let autoHide = true;
    const me = this;
    const {
      page: { pageId }, page: { pageMetaData }
    } = this.props;
    const { showAlert, alertType } = this.state;
    if (!showAlert) return null;
    switch (alertType) {
      case ALERT_TYPES.TIMED_QUIZ:
        const duration = pageMetaData.questionConfig.getDuration();
        const minutes = Math.floor(duration / 60);
        const seconds = duration % 60;
        const time = `${
          minutes > 0 ? `${minutes} minute${minutes > 1 ? "s" : ""}` : ""
        } ${seconds > 0 ? `${seconds} second${seconds > 1 ? "s" : ""}` : ""}`;
        toRender = [
          <span>This card contains a quiz.</span>,
          <img src={TimerImage} />,
          <span>{`You have ${time} to answer.`}</span>,
          <AppButton buttonLabel="Start" clickHandler={this.hideAlert} />
        ];
        autoHide = false;
        break;
      case ALERT_TYPES.CORRECT_ANSWER:
        toRender = [
          <img key={'accomplishmentImage'} src={AccomplishmentImage} />,
          <span>Yay!</span>,
          <span>You got that right</span>
        ];
        cls = "correct-answer";
        break;
      case ALERT_TYPES.WRONG_ANSWER:
        toRender = [
          <img key={'disappointmentImage'} src={DisappointmentImage} />,
          <span>Oops!</span>,
          <span>That's the wrong answer</span>
        ];
        cls = "wrong-answer";
        break;
      case ALERT_TYPES.TIMED_OUT:
        toRender = [
          <img  key={'disappointmentImage'} src={DisappointmentImage} />,
          <span>Timed Out!</span>,
          <span>You ran out of time</span>
        ];
        cls = "wrong-answer";
        break;
      case ALERT_TYPES.REATTEMPT_QUIZ:
          toRender = [
            <img key={'disappointmentImage'} src={DisappointmentImage}/>,
            <span>You got it wrong in the last attempt. Do you want to give it another try?</span>,
            <AppButton buttonLabel="Yes" clickHandler={this.reattemptQuiz}/>,
            <AppButton buttonLabel="No" 
                       buttonCls="cancellation"    
                       clickHandler={this.hideAlert}/>
          ];
          cls = "wrong-answer";
          autoHide = false;
          break;
      default:
        break;
    }

    if(autoHide && this.state.showAlert){
      setTimeout(() => {
        const node = document.querySelector(`.page_${pageId} .question-container`);
        if(node && me.props.isPageActive){
          node.scrollIntoView({behavior: "smooth", block: 'nearest'});
        }
        me.hideAlert();
      }, 2000);
    }

    return (
      <div className={`alert-overlay ${showAlert ? '' : 'fade-out'}`}>
        <div className={`alert-wrapper ${cls}`}>{toRender}</div>
      </div>
    );
  };

  hideAlert = () => {
    this.setState({
      showAlert: false
    });
  }

  reattemptQuiz = () => {
    this.props.page.pageMetaData.questionResponse.performReattempt();
    const { matchSources, matchTargets } = this.getShuffledMatchOptions();
    this.setState({
      showAlert: false,
      userSelection: [],
      matchSources,
      matchTargets
    });
  }

  getShuffledMatchOptions = () => {
    const { page } = this.props;
    let response = { matchSources: [], matchTargets: [] };
    if(page.pageMetaData.isQuiz()
        && page.pageMetaData.questionConfig.getIsMatchOptions()
    ){
      //construct source and target pageitems
      const notQuestion = item => item.itemContent.group !== 'question';
      const pageItems = page.pageItems.filter(notQuestion);
      const isSource = item => item.itemContent.matchEntityType === 'source'; 
      const isTarget = item => item.itemContent.matchEntityType === 'target'; 
      const toArray = item => [].concat(item);
      response['matchSources'] = pageItems.filter(isSource).map(toArray);
      response['matchTargets'] = this.shuffle(pageItems.filter(isTarget)).map(toArray);
    }
    return response;
  }

  getFlashcardPageItems = () => {
    const { page, isPageActive } = this.props;
    const { rendered } = this.state;
    if (!rendered && !isPageActive) {
      return null;
    }
    let pageItemsUI = [];
    let alignmentCls = "";
    if (page.pageMetaData.isQuiz()) {
      return this.getFlashcardQuestionPageItems();
    } else {
      alignmentCls = this.getContentAlignmentCssCls();
      const pageItemsToRender = page.pageItems.filter(item => !item.isAudio());
      pageItemsUI = pageItemsToRender.map(this.getPageItem());
      if (
        pageItemsToRender.length === 1 &&
        !pageItemsToRender[0].isVertical() &&
        !page.pageMetaData.contentAlignment
      ) {
        return <div className="single-item-wrapper">{pageItemsUI}</div>;
      }
    }
    return <div className={`full-height ${alignmentCls}`}>{pageItemsUI}</div>;
  };

  getContentAlignmentCssCls = () => {
    let alignmentCls = "";
    const {
      page: { pageMetaData }
    } = this.props;
    if (
      pageMetaData.contentAlignment !==
      FlashcardPageMetaData.ALIGNMENT_TYPES.NONE
    ) {
      alignmentCls = "flex-alignment";
      switch (pageMetaData.contentAlignment) {
        case FlashcardPageMetaData.ALIGNMENT_TYPES.CENTER:
          alignmentCls += " flex-center";
          break;
        case FlashcardPageMetaData.ALIGNMENT_TYPES.FLEX_START:
          alignmentCls += " flex-start";
          break;
        case FlashcardPageMetaData.ALIGNMENT_TYPES.FLEX_END:
          alignmentCls += " flex-end";
          break;
        case FlashcardPageMetaData.ALIGNMENT_TYPES.SPACE_AROUND:
          alignmentCls += " flex-space-around";
          break;
        case FlashcardPageMetaData.ALIGNMENT_TYPES.SPACE_BETWEEN:
          alignmentCls += " flex-space-between";
          break;
        case FlashcardPageMetaData.ALIGNMENT_TYPES.SPACE_EVENLY:
          alignmentCls += " flex-space-evenly";
          break;
        default:
          alignmentCls = "";
          break;
      }
    }
    return alignmentCls;
  };

  getFlashcardQuestionPageItems = () => {
    const groupItemsMap = this.props.page.pageItems.reduce(
      (previous, current) => {
        previous[current.itemContent.group] = [
          ...(previous[current.itemContent.group] || []),
          current
        ];
        return previous;
      },
      {}
    );
    const { userSelection } = this.state;
    const {
      page: { pageMetaData },
      page: {
        pageMetaData: { questionResponse }
      }
    } = this.props;
    const questionGroup = Object.keys(groupItemsMap)
      .filter(groupKey => groupKey.includes("question"))
      .pop();
    const question = groupItemsMap[questionGroup].map(this.getPageItem());
    const isAnswered = questionResponse.isAnswered();
    const { themeBackgroundColor, themeColor, previewLayout } = this.props;

    var options = [];
    if(pageMetaData.questionConfig.getIsMatchOptions()){
      options = this.getDragAndDropOptions();
    }else{
      options = this.getClickOptions(groupItemsMap);
    }
    this.addButtonThemeStyle();
    const submitButton = isAnswered ? (
      ""
    ) : (
      <div className="submit-button-container">
        <AppButton
          buttonCls="flashcard_themed_button"
          disabled={pageMetaData.questionConfig.getIsMatchOptions() ? !this.isMatchCompleted() : (userSelection.length === 0)}
          buttonLabel="Submit"
          clickHandler={this.submitQuestionResponse}
        />
      </div>
    );
    return (
      <div className="question-answer-container">
        <div
          className="question-container"
          style={{
            backgroundColor: previewLayout === "fixed" ? themeColor : themeBackgroundColor,
            color: previewLayout === "fixed" ? themeBackgroundColor : themeColor,
          }}
        >
          <div className="question-wrapper">{question}</div>
        </div>
        {isAnswered ? this.getQuizResultInfoSection() : (null)}
        {options}
        {submitButton}
      </div>
    );
  };

  getClickOptions(groupItemsMap){
    const {
      page: { pageMetaData },
      page: {
        pageMetaData: { questionResponse }
      }
    } = this.props;
    const { userSelection } = this.state;
    const isMultiChoice = pageMetaData.questionConfig.getIsMultiChoice();
    const isAnswered = questionResponse.isAnswered();
    return Object.keys(groupItemsMap)
      .filter(groupKey => !groupKey.includes("question"))
      .map(key => groupItemsMap[key])
      .map(pageItems => {
        const optionGroup = pageItems[0].itemContent.group;
        const answer = pageMetaData.getCorrectOption();
        const items = pageItems.map(this.getPageItem(false), this);
        const userAnswer = isAnswered
          ? questionResponse.getAnswer()
          : userSelection;
        const isChecked =
          (userAnswer.indexOf(optionGroup) > -1) || (isAnswered && answer.indexOf(optionGroup) > -1);
        const isCorrect =
          isChecked &&
          (!isAnswered || answer.indexOf(optionGroup) > -1);
        return (
          <div
            className={`answer-container ${isAnswered ? (!isChecked ? "" : (isCorrect ? "correct" : "wrong")) : ""}`}
            key={optionGroup}
            onClick={this.onOptionSelect.bind(null, optionGroup)}
          >
            {
              isAnswered
              ? <span className="alpa-numbering">({this.getOptionsAlphaNumbering(optionGroup)})</span>
              : <Checkbox 
                  disabled={isAnswered}
                  checked={isChecked}
                  cls={`flashcard-answer-button ${isMultiChoice ? "" : "round-checkbox"}`} />
            }
            <div className="answer-wrapper">{items}</div>
          </div>
        );
      }, this);
  }

  getDragAndDropOptions(){
    let { matchSources, matchTargets } = this.state;
    if(matchSources.length === 0 && matchTargets.length === 0){ return (null); }
    const { page } = this.props;
    const isAnswered = page.pageMetaData.questionResponse.isAnswered();
    const isSourceItem = item => item.itemContent.matchEntityType === 'source';
    const isTargetItem = item => item.itemContent.matchEntityType === 'target';
    var me = this;
    if(isAnswered){
      //construct source and target pageitems
      const notQuestion = item => item.itemContent.group !== 'question';
      const pageItems = page.pageItems.filter(notQuestion);
      const toArray = item => [].concat(item);
      matchSources = pageItems.filter(isSourceItem).map(toArray);
      matchTargets = pageItems.filter(isTargetItem).map(toArray);
    }

    let dragData;
    const onDragStart = function(event){
      if(isAnswered){
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      me.props.onDnDStart();
      const el = event.target;
      const cloneEl = el.cloneNode(true);
      const bbox = el.getBoundingClientRect();
      const screenTouch = event.touches[0];
      el.style.opacity = '0';
      cloneEl.style.cssText = `
        width: ${bbox.width}px;
        height: ${bbox.height}px;
        position: absolute;
        left: -${screenTouch.pageX - bbox.x}px !important;
        top: -${screenTouch.pageY - bbox.y}px !important;
        -webkit-transform: translate(${screenTouch.pageX}px, ${screenTouch.pageY}px);
           -moz-transform: translate(${screenTouch.pageX}px, ${screenTouch.pageY}px);
            -ms-transform: translate(${screenTouch.pageX}px, ${screenTouch.pageY}px);
             -o-transform: translate(${screenTouch.pageX}px, ${screenTouch.pageY}px);
                transform: translate(${screenTouch.pageX}px, ${screenTouch.pageY}px);
        backface-visibility: hidden;
      `;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'relative';

      document.body.appendChild(cloneEl);
      dragData = {
        el: event.target,
        cloneEl: cloneEl,
        droppableEls: document.querySelectorAll(`.flashcard-page.page_${page.pageId} .answer-container .droppable`),
        draggableId: event.target.getAttribute('data-draggableId'),
        lastTouch: screenTouch
      };
      document.addEventListener('touchmove', onDrag);
      document.addEventListener('touchend', onDragEnd);
      const containerWrapperEl = document.querySelector(`.flashcard-page.page_${page.pageId} .item-collection`);
      if(containerWrapperEl){
        containerWrapperEl.style.overflow = 'hidden';
      }
    }

    const onDrag = function(event){
      event.preventDefault();
      event.stopPropagation();
      const cloneEl = dragData.cloneEl;
      const screenTouch = event.touches[0];
      cloneEl.style['webkitTransform'] = `translate(${screenTouch.pageX}px, ${screenTouch.pageY}px)`;
      cloneEl.style['mozTransform'] = `translate(${screenTouch.pageX}px, ${screenTouch.pageY}px)`;
      cloneEl.style['msTransform'] = `translate(${screenTouch.pageX}px, ${screenTouch.pageY}px)`;
      cloneEl.style['oTransform'] = `translate(${screenTouch.pageX}px, ${screenTouch.pageY}px)`;
      cloneEl.style['transform'] = `translate(${screenTouch.pageX}px, ${screenTouch.pageY}px)`;
      //check if touch move over droppable elements
      let droppableId = null;
      dragData.droppableEls.forEach(node => {
        const bbox = node.getBoundingClientRect();
        if((screenTouch.pageX > bbox.left && screenTouch.pageX < (bbox.left + bbox.width))
          && (screenTouch.pageY > bbox.top && screenTouch.pageY < (bbox.top + bbox.height))){
            node.classList.add('dragOver');
            droppableId = node.getAttribute('data-droppableId');
            node.scrollIntoView({behavior: "smooth", block: 'nearest'});
          }else{
            node.classList.remove('dragOver');
          }
      });
      
      dragData['droppableId'] = droppableId;

      const contentWrapperEl = document.querySelector(`.flashcard-page.page_${page.pageId} .item-collection`);
      const contentBbox = contentWrapperEl.getBoundingClientRect();
      if(screenTouch.pageY > (document.body.clientHeight * .8) 
        && contentWrapperEl.scrollTop <  (contentWrapperEl.scrollHeight - contentBbox.height)
        && dragData.lastTouch.pageY < screenTouch.pageY){
        contentWrapperEl.scrollTop += 5;
      }
      if(screenTouch.pageY < (document.body.clientHeight * .2) 
        && contentWrapperEl.scrollTop > 0
        && dragData.lastTouch.pageY > screenTouch.pageY){
        contentWrapperEl.scrollTop = Math.max(contentWrapperEl.scrollTop - 5, 0);
      }
      dragData['lastTouch'] = screenTouch;
    }

    const onDragEnd = function(event){
      event.preventDefault();
      event.stopPropagation();
      dragData.el.style.opacity = '1';
      dragData.cloneEl.parentElement.removeChild(dragData.cloneEl);
      document.removeEventListener('touchmove', onDrag);
      document.removeEventListener('touchend', onDragEnd);
      dragData.droppableEls.forEach(node => {
        node.classList.remove('dragOver');
      });

      if(!!dragData && !!dragData.droppableId){
        //perform drop
        let sources = me.state.matchSources;
        let targets = me.state.matchTargets;
        let tmp;
        const dropIndex = parseInt(dragData.droppableId.split('_').pop())
        const draggingIndex = parseInt(dragData.draggableId.split('_').pop());
        const isDropTarget = dragData.droppableId.split('_')[0] === 'target';
        const isDraggingTarget = dragData.draggableId.split('_')[1] === 'target';
        if(isDropTarget){
            tmp = (isDraggingTarget ? targets : sources)[draggingIndex].pop();
            targets[dropIndex] = targets[dropIndex].concat(tmp);
        }else{
            tmp = (isDraggingTarget ? targets : sources)[draggingIndex].filter(isSourceItem);
            (isDraggingTarget ? targets : sources)[draggingIndex] = (isDraggingTarget ? targets : sources)[draggingIndex].filter(isTargetItem);
            sources[dropIndex] = sources[dropIndex].concat(tmp);
        }
        me.setState({
          matchSources: sources,
          matchTargets: targets
        }, () => {
          if(me.isMatchCompleted()){
              const pageId = page.pageId;
              const submitBtn = document.querySelector(`.page_${pageId} .submit-button-container`);
              if(submitBtn){
                  submitBtn.scrollIntoView({behavior: "smooth", block: 'nearest'});
              }
          }
        });
      }
      const containerWrapperEl = document.querySelector(`.flashcard-page.page_${page.pageId} .item-collection`);
      if(containerWrapperEl){
        containerWrapperEl.style.overflow = 'auto';
      }
    }

    return (
      <div className="answer-container match-options">
          {
              matchSources.map((sources, i) => {
                  let targets = matchTargets[i];
                  const isSourceMapped = sources.length === 0;
                  const isTargetMapped = targets.length > 1;
                  return (
                    <div className="match-row-wrapper">
                        <div className={`match-source-container ${isSourceMapped ? 'droppable' : 'empty'}`}
                              key={`source_container_${i}`}
                              data-droppableId={`source_${i}`}>
                            <div className={`match-source-content`}
                                  key={`source_draggable_${i}`}
                                  onTouchStart={isSourceMapped ? () => {} : onDragStart}
                                  data-draggableId={`draggable_source_${i}`}>
                            {
                              sources.map(this.getPageItem(false), me)
                            }
                            </div>
                        </div>
                        <div className={`match-target-container ${isTargetMapped ? 'mapped' : 'droppable'}`}
                              key={`target_container_${i}`}
                              data-droppableId={`target_${i}`}>
                            {
                              isTargetMapped 
                              ? <div className={`match-source-content`}
                                  key={`target_draggable_${i}`}
                                  onTouchStart={isTargetMapped ? onDragStart : () => {}}
                                  data-draggableId={`draggable_target_${i}`}>
                                  {
                                    targets.filter(isSourceItem).map(this.getPageItem(false), me)
                                  }
                                </div>
                              : (null)
                            }
                            <div className="match-target-content" key={`target_content_${i}`}>
                            {
                              targets.filter(isTargetItem).map(this.getPageItem(false), me)
                            }
                            </div>
                        </div>
                      </div>
                  );
              }, this)
          }
      </div>
    );
  }

  isMatchCompleted(){
    return this.state.matchSources.filter(sources => sources.length > 0).length === 0;
  }

  componentDidUpdate() {
    this.updateRenderedState();
  }

  updateRenderedState() {
    if (!this.state.rendered && (this.props.isPageActive || this.props.isItemToBeloaded)) {
      const me = this;
      setTimeout(() => {
        me.setState({
          rendered: true
        });
      }, 150)
    } 
	
	if(this.state.rendered && this.props.isPageActive && !this.state.pageViewed) {
		this.setState({
			pageViewed: true
		})
	}
  }

  getQuizTimer = () => {
    const {
      page: { pageMetaData },
      isPageActive,
      themeColor,
      themeBackgroundColor
    } = this.props;
    const { questionConfig, questionResponse } = pageMetaData;
    const { showAlert } = this.state;
    if (
      (!isPageActive && !questionResponse.isAnswered()) ||
      showAlert ||
      !pageMetaData.isQuiz() ||
      (!questionConfig.getIsMandatory() && !questionResponse.isAnswered()) ||
      (questionConfig.getDuration() === 0 && !questionResponse.isAnswered())
    ) {
      return "";
    }
    if (questionResponse.isAnswered()) {
      return (null);
    }
    return (
      <CountDownTimer
        ref="countDownTimer"
        ctrCls="quiz-view-timer"
        countDownDuration={
          questionResponse.isTimedOut()
            ? 0
            : questionConfig.getDuration() * 1000
        }
        onCountDownComplete={this.setQuestionUnanswered}
        backgroundColor={themeBackgroundColor}
        color={themeColor}
        countDownCompletedMessage="Missed"
      />
    );
  };

  getQuizResultInfoSection = () => {
    let msg = "";
    let cls = "";
    const {
      page: { pageMetaData }
    } = this.props;
    const questionResponse = pageMetaData.questionResponse;
    const correctOption = pageMetaData.getCorrectOption().map(this.getOptionsAlphaNumbering).sort().join(', ');
    const selectedOption = questionResponse.getAnswer().map(this.getOptionsAlphaNumbering).sort().join(', ');
    let answerMsg = `The Right answer is '${correctOption}'`;
    if (questionResponse.isTimedOut()) {
      msg = "Timed Out!";
      cls = "wrong-answer";
    } else {
      if (questionResponse.isCorrect) {
        msg = "Yay! You got it right!";
        cls = "correct-answer";
      } else {
        msg = `Oops! '${selectedOption}' is incorrect!`;
        cls = "wrong-answer";
        if(pageMetaData.questionConfig.getIsMatchOptions()){
          msg = "Oops! You got it wrong!";
        }
      }
    }
    if(pageMetaData.questionConfig.getIsMatchOptions()){
      answerMsg = "The Right answer is shown below."
    }
    return (
      <div className={`quiz-result-alert ${cls}`}>
        <div className="result-indicator-icon">
          <img src={HandImage} />
        </div>
        <div className="result-info">
          <span>{msg}</span>
          <span>{answerMsg}</span>
        </div>
      </div>
    );
  };

  getOptionsAlphaNumbering = option => {
    const {
      page: { pageItems }
    } = this.props;
    const allOptions = Object.keys(
      pageItems.reduce((previous, current) => {
        if (current.itemContent.group !== "question") {
          previous[current.itemContent.group] = "";
        }
        return previous;
      }, {})
    );
    var index = allOptions.indexOf(option);
    if (index === -1) {
      return;
    }
    const alphCount = 26;
    let optionAlphaString = "";
    if (index === 0) return "A";
    while (index >= 0) {
      optionAlphaString =
        String.fromCharCode("A".charCodeAt() + (index % alphCount)) +
        optionAlphaString;
      index = Math.floor(index / alphCount) - 1;
    }
    return optionAlphaString;
  };

  addButtonThemeStyle = () => {
    let style = document.getElementById("flashcard_inline_theme_styles");
    if (!style) {
      style = document.createElement("style");
      style.id = "flashcard_inline_theme_styles";
      document.body.appendChild(style);
    }
    const { themeBackgroundColor, themeColor } = this.props;
    var css = `
      .flashcard_themed_button {
        background-color: ${themeBackgroundColor} !important;
        color: ${themeColor} !important;
        border: solid 1px ${themeColor} !important;
      }
      .flashcard_themed_button:not(.btn-disabled):hover,
      .flashcard_themed_button:not(.btn-disabled):active {
        background-color: ${themeColor} !important;
        color: ${themeBackgroundColor} !important;
        border: solid 1px ${themeBackgroundColor} !important;
      }`;
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.textContent = css;
    }
  };

  setQuestionUnanswered = () => {
    const { page, onQuestionSubmit } = this.props;
    let { userSelection } = this.state;
    let isTimedOut = false;
    /**
     * if any options is selected by the user
     * then mark that as the user choice
     * if not then mark the response as timedout
     * */
    if(page.pageMetaData.questionConfig.getIsMatchOptions()){
      userSelection = this.state.matchTargets;
      if(userSelection.filter(function(arr){ return arr.length < 2; }).length > 0){
        isTimedOut = true;
        page.pageMetaData.questionResponse.markAsTimedOut();
      }
    } else if(userSelection.length === 0){
      isTimedOut = true;
      page.pageMetaData.questionResponse.markAsTimedOut();
    }
    onQuestionSubmit(page, userSelection);
    this.setState({
      showAlert: true,
      alertType:
        isTimedOut
          ? ALERT_TYPES.TIMED_OUT
          : page.pageMetaData.questionResponse.isCorrect
          ? ALERT_TYPES.CORRECT_ANSWER
          : ALERT_TYPES.WRONG_ANSWER
    });
  };

  onOptionSelect = optionGroup => {
    let { userSelection } = this.state;
    const { page } = this.props
    if(!page.pageMetaData.questionConfig.getIsMultiChoice()){
        userSelection = [optionGroup];
    } else if(userSelection.indexOf(optionGroup) > -1){
        userSelection = userSelection.filter(opt => opt !== optionGroup);
    }else{
        userSelection = userSelection.concat(optionGroup);
    }
    this.setState({
      userSelection
    });
  }

  submitQuestionResponse = () => {
    let { userSelection } = this.state;
    const { page, onQuestionSubmit } = this.props;
    if(page.pageMetaData.questionConfig.getIsMatchOptions()){
      userSelection = this.state.matchTargets;
    }
    onQuestionSubmit(page, userSelection);
    this.setState({
      showAlert: true,
      alertType: page.pageMetaData.questionResponse.isCorrect
        ? ALERT_TYPES.CORRECT_ANSWER
        : ALERT_TYPES.WRONG_ANSWER
    });
  };

  getPageItem = (applyTheme = true) => pageItem => {
    const { themeColor,themeBackgroundColor, isPageActive, previewLayout } = this.props;
    let ItemComponent = FlashcardText;
    switch (pageItem.itemType) {
      case AUDIO:
        ItemComponent = FlashcardAudio;
        break;
      case VIDEO:
        ItemComponent = FlashcardVideo;
        break;
      case IMAGE:
        ItemComponent = FlashcardImage;
        break;
      default:
        break;
    }
    return (
      <ItemComponent
        key={pageItem.pageItemId}
        pageItem={pageItem}
        themeColor={ themeColor }
        themeBackgroundColor={themeBackgroundColor}
        previewLayout={previewLayout}
        applyTheme={applyTheme}
        isPageActive={isPageActive}
        onLoadComplete={this.onPageItemLoaded}
        forwardRef={`pageItem_${pageItem.pageItemId}`}
      />
    );
  };
}

export default FlashcardPageView;
